import React from 'react'
import DeleteIcon from '@/icons/delete.svg'

interface Option {
  text: string
  position: number
}

interface MultipleOptionQuestionProps {
  questionId: number
  body: string
  required: boolean
  options: Option[]
  readOnly?: boolean
  onAddOption?: () => void
  onRemoveOption?: (index: number) => void
  onUpdateOption?: (index: number, value: string) => void
}

const MultipleOptionQuestion: React.FC<MultipleOptionQuestionProps> = ({
  questionId,
  body,
  options,
  readOnly = false,
  onAddOption,
  onRemoveOption,
  onUpdateOption
}) => {
  // Ordenar las opciones por position antes de renderizar
  const sortedOptions = [...options].sort((a, b) => a.position - b.position)
  return (
    <div className="question-container">
      <div className="question-body mb-3">
        <p className="font-bold text-gray-800">{body}</p>
      </div>

      <div className="options-container space-y-2">
        {readOnly ? (
          // Display mode
          <div className="flex flex-col gap-4">
            {sortedOptions.map((option, index) => (
              <div key={`${questionId}-${index}`} className="flex items-center">
                <input
                  type="radio"
                  name={`question-${questionId}`}
                  id={`question-${questionId}-option-${index + 1}`}
                  className="form-radio appearance-none flex-shrink-0 h-6 w-6 border-2 rounded-full"
                  style={{ minWidth: '1.5rem', minHeight: '1.5rem' }}
                  onChange={() => onUpdateOption?.(index, option.text)}
                />
                <label
                  id={`label-question-${questionId}-option-${index + 1}`}
                  htmlFor={`question-${questionId}-option-${index + 1}`}
                  className="ml-3 block text-sm font-medium text-gray-800 cursor-pointer"
                >
                  {option.text}
                  <span className="sr-only"> (P{questionId})</span>
                </label>
              </div>
            ))}
          </div>
        ) : (
          // Edit mode
          <>
            {sortedOptions.map((option, index) => (
              <div key={`${questionId}-${index}`} className="flex items-center gap-2">
                <input
                  type="text"
                  value={option.text}
                  onChange={e => onUpdateOption?.(index, e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  required
                />
                <button
                  type="button"
                  onClick={() => onRemoveOption?.(index)}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <img src={DeleteIcon} alt="Delete" className="h-6 w-6" />
                </button>
              </div>
            ))}

            <button type="button" onClick={onAddOption} className="text-blue-600 hover:text-blue-800 mt-2">
              <i className="fas fa-plus mr-1"></i>
              Agregar alternativas
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default MultipleOptionQuestion
